import React from 'react'
import ReactDOM from 'react-dom/client'
import AppShell from '@/shared/components/AppShell'
import AdminApp from './AdminApp'
import '@/shared/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <AppShell>
    <AdminApp />
  </AppShell>
)

